var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "Edit TA",
        visible: _vm.dialogVisible,
        scrollbar: false,
        width: "400px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        open: _vm.onOpen,
        closed: _vm.onClosed,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "padding-lr",
          attrs: {
            model: _vm.form,
            rules: _vm.formRules,
            "label-position": "top",
          },
          nativeOn: {
            submit: function ($event) {
              $event.preventDefault()
            },
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { prop: "taConfigId", label: "TA" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: { placeholder: "Please select TA", filterable: "" },
                  on: {
                    change: function ($event) {
                      _vm.noMatch = false
                    },
                  },
                  model: {
                    value: _vm.form.taConfigId,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "taConfigId", $$v)
                    },
                    expression: "form.taConfigId",
                  },
                },
                _vm._l(_vm.taList, function (item) {
                  return _c("el-option", {
                    key: item.taConfigId,
                    attrs: { label: item.taConfigName, value: item.taConfigId },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.submitLoading },
              on: { click: _vm.onSave },
            },
            [_vm._v(" Save ")]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(" Cancel ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }